import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  axiosInstance,
  axiosInstancePython,
} from "../../utils/axiosInstance";
import {
  ScheduleProgrammingTestEndPoint,
  PythonCodingTestEndPoint,
} from "../../api-routes";

const validateProgrammingTest = async (data) => {
  return (
    await axiosInstance.post(
      ScheduleProgrammingTestEndPoint.VALIDATE_PROGRAMMING_TEST,
      data,
    )
  ).data;
};

const sendProgrammingTestOTP = async (data) => {
  return (
    await axiosInstance.post(
      ScheduleProgrammingTestEndPoint.SEND_PROGRAMMING_TEST_OTP,
      data,
    )
  ).data;
};

const submitProgrammingTest = async (data) => {
  return (
    await axiosInstance.post(
      ScheduleProgrammingTestEndPoint.SUBMIT_PROGRAMMING_TEST,
      data,
    )
  ).data;
};

const blockProgrammingTest = async (id) => {
  return (
    await axiosInstance.put(
      `${ScheduleProgrammingTestEndPoint.BLOCK_PROGRAMMING_TEST}/${id}`,
    )
  ).data;
};

const downloadTestReport = async (id) => {
  const response = await axiosInstance.get(
    `${ScheduleProgrammingTestEndPoint.DOWNLOAD_TEST_REPORT}/${id}`,
    { responseType: "blob" },
  );
  const blob = response.data;
  if (blob && response.headers?.["x-report-generated"] === "true") {
    blob.wasGenerated = true;
  }
  return blob;
};

const verifyFaceVideo = async ({ formData, candidateId }) => {
  return (
    await axiosInstancePython.post(
      `${PythonCodingTestEndPoint.VERIFY_FACE_VIDEO}/?candidate_id=${candidateId}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } },
    )
  ).data;
};

export const useValidateProgrammingTest = () => {
  return useMutation({
    mutationFn: (data) => validateProgrammingTest(data),
  });
};

export const useSubmitProgrammingTest = () => {
  return useMutation({
    mutationFn: (data) => submitProgrammingTest(data),
  });
};

export const useBlockProgrammingTestById = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: blockProgrammingTest,
    onSuccess: () => {
      queryClient.invalidateQueries(["allProgrammingTests"]);
    },
  });
};

export const useDownloadTestReport = () => {
  return useMutation({
    mutationFn: (id) => downloadTestReport(id),
  });
};

export const useVerifyFaceVideo = () => {
  return useMutation({
    mutationFn: (data) => verifyFaceVideo(data),
  });
};

export const useSendProgrammingTestOTP = () => {
  return useMutation({
    mutationFn: (data) => sendProgrammingTestOTP(data),
    onError: (err) => console.error("Send programming test OTP failed:", err),
  });
};
